import type { ReactElement } from 'react';

export type VolumeProductFilter = 'all' | 'oil' | 'gas';

export interface VolumeTileCounts {
  all: number;
  oil: number;
  gas: number;
}

interface VolumeTilesProps {
  counts: VolumeTileCounts;
  filter: VolumeProductFilter;
  onFilter: (filter: VolumeProductFilter) => void;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

export function VolumeTiles({ counts, filter, onFilter }: VolumeTilesProps): ReactElement {
  return (
    <section className="tiles-grid" data-testid="volume-tiles">
      <article className={tileClass(filter === 'all')} onClick={() => onFilter('all')}>
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article className={tileClass(filter === 'oil')} onClick={() => onFilter('oil')}>
        <h3>Oil</h3>
        <p>{counts.oil}</p>
      </article>
      <article className={tileClass(filter === 'gas')} onClick={() => onFilter('gas')}>
        <h3>Gas</h3>
        <p>{counts.gas}</p>
      </article>
    </section>
  );
}
